import type { PublishMetadataValues } from './wildmoka_iframe_api/messages';

export type MetadataByObjectTypeResponse = {
  [fieldName: string]: {
    name: string;
    type: string;
    values: { value: string }[];
  };
};

export function convertMetadataValuesToWildmokaFormat(
  metadataFieldValues: MetadataByObjectTypeResponse,
): PublishMetadataValues {
  const metadataValues: PublishMetadataValues = {};
  for (const [fieldName, fieldEntry] of Object.entries(metadataFieldValues)) {
    const values = fieldEntry.values
      .map((entry) => {
        const { value } = entry;
        if (value === undefined || value === null) {
          return undefined;
        }
        if (fieldEntry.type === 'boolean') {
          if (value === 'true') {
            return true;
          } else if (value === 'false') {
            return false;
          }
        }

        return value;
      })
      .filter((value) => value !== undefined);

    if (!values.length) {
      continue;
    }
    metadataValues[fieldName] = values.length === 1 ? values[0] : values;
  }
  return metadataValues;
}
